// src/pages/tfdAccelerate/TFDAccelerate.js

import { Link } from "react-router-dom";
import React from "react";

const TFDAccelerate = () => {
	return (
		<div className="container" style={{ padding: "60px 20px" }}>
			<h1>TFD ACCELERATE</h1>
			<p>
				Welcome to Total Football Development Accelerate—our cutting-edge
				program designed to fast-track player growth on and off the pitch.
			</p>
			<ul>
				<li>
					<Link to="/tfd-accelerate/academy">Academy</Link>
				</li>
				<li>
					<Link to="/tfd-accelerate/private-sessions">Private Sessions</Link>
				</li>
				<li>
					<Link to="/tfd-accelerate/perth-europa-league">
						Perth Europa League
					</Link>
				</li>
				<li>
					<Link to="/tfd-accelerate/camps">Camps</Link> (Info Needed)
				</li>
				<li>
					<Link to="/tfd-accelerate/schools">Schools</Link> (Info Needed)
				</li>
				<li>
					<Link to="/tfd-accelerate/little-superstars">Little Superstars</Link>{" "}
					(Info Needed)
				</li>
				<li>
					<Link to="/tfd-accelerate/national-tours">National Tours</Link> (Info
					Needed)
				</li>
				<li>
					<Link to="/tfd-accelerate/international-experience">
						International Experience
					</Link>{" "}
					(Info Needed)
				</li>
			</ul>
		</div>
	);
};

export default TFDAccelerate;
